import React from 'react';

const Preloader: React.FC = () => {
  return (
    <div className="preloader">
      <div className="preloader-inner">
        <img src="/assets/img/logo.png" alt="logo" />
        <span className="loader"></span>
      </div>
    </div>
  );
};

export default Preloader;
